import { useCms } from "@/context/CmsContext";
import { useAuth } from "@/context/AuthContext";
import { PencilLine, Eye } from "@phosphor-icons/react";

/**
 * Floating button visible only to admin / trainer users on public-facing pages.
 * Toggles "Edit mode" — when on, every <Editable> element shows a pencil overlay
 * so admins can click to inline-edit text.
 */
export default function CmsEditToggle() {
  const { user } = useAuth();
  const { editMode, setEditMode } = useCms();
  if (!user || (user.role !== "admin" && user.role !== "trainer")) return null;

  return (
    <button
      type="button"
      onClick={() => setEditMode(!editMode)}
      className={`cms-edit-toggle ${editMode ? "cms-edit-toggle--on" : ""}`}
      data-testid="cms-edit-toggle"
      aria-label={editMode ? "Exit edit mode" : "Enter edit mode"}
    >
      {editMode ? <Eye size={18} weight="bold" /> : <PencilLine size={18} weight="bold" />}
      <span>{editMode ? "Exit edit" : "Edit page"}</span>
    </button>
  );
}
